<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2>Links Administration</h2>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-12">
        <card>
          <div slot="header"><h4 class="card-title">{{title}} Report Links</h4></div>
          <div class="row">
            <div class="col-sm-12">
              <el-table :data="links" row-key="id" 
                :default-sort="{ prop: 'name', order: 'ascending' }"
                :row-class-name="tableRowClassName"
                default-expand-all>
                <el-table-column min-width="150" prop="name" label="Id" sortable></el-table-column>
                <el-table-column v-if="mode !== 2" min-width="200" prop="surveyName" label="Survey Name" sortable></el-table-column>
                <el-table-column v-if="mode !== 3" min-width="120" prop="surveyUrlId" label="Survey Instance"></el-table-column>
                <el-table-column min-width="100" prop="role" label="Access Level"></el-table-column>
                <el-table-column min-width="350" prop="url" label="Url"></el-table-column>
                <el-table-column mind-width="200" align="right" label="Actions">
                  <template scope="scope">
                    <base-button v-if="scope.row.dataType > 0" class="btn-link" type="secondary" size="sm" icon>
                      <span class="sr-only">Edit Link</span>
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                    <base-button v-if="scope.row.dataType > 0" @click="onDelete(scope.row)" class="btn-link" type="danger" size="sm" icon>
                      <span class="sr-only">Delete Link</span>
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui';
import { mapGetters } from 'vuex';
import { getReportLinks, deleteReportLink, getRolesAsync } from 'src/modules/adminActions';
import BaseButton from 'src/components/BaseButton.vue';
import swal from 'sweetalert2';
import { isNullOrEmpty } from '../../modules/utils';

export default {
  components: {
    BaseButton,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      title: "URL",
      modes: { default: 1, surveyId: 2, surveyUrlId: 3 },
      dataTypes: { header: 0, parent: 1, child: 2 },
      links: [],
      roles: [],
      routeInfo: { name: "", path: "" },
    }
  },
  computed: {
    mode() {
      return this.$route.params.surveyId && this.$route.params.surveyUrlId ? this.modes.surveyUrlId
        : this.$route.params.surveyId ? this.modes.surveyId
        : this.modes.default;
    },
    multiChildrenLinks() {
      if (this.links.length === 0) {
        return 0;
      }

      const finds = this.links.filter(x => x.hasOwnProperty("children") && x.children.length > 0);
      return finds.length;
    },
    ...mapGetters({
      getSurveyById: 'getSurveyById',
      getOrgSurveyById: 'getOrgSurveyById',
    })
  },
  methods: {
    async getRoles() {
      this.roles = await getRolesAsync();
    },
    getLinks() {
      const params = this.$route.params;
      getReportLinks(params)
        .then(response => {
          this.formatReportLinks(response.data);
        });
    },
    formatReportLinks(data) {
      const srcRegex = /src=[^<]+?"/i;
      let count = 0;
      let uniqueUrls = [...new Set(data.filter(x => !isNullOrEmpty(x.url)).map(x => x.url))];
      let uniqueHtmlUrls = [...new Set(data.filter(x => !isNullOrEmpty(x.html)).map(x => {
        let url = null;
        const regexMatch = x.html.match(srcRegex);
        if (regexMatch.length > 0) {
          url = regexMatch[0].replace("src=", "").replace(/"/g, "");
        }

        return url;
      }))];

      if (uniqueHtmlUrls.length > 0) {
        uniqueHtmlUrls = uniqueHtmlUrls.filter(x => !isNullOrEmpty(x));
      }

      // Combine the urls and htmls and form a new set of unique urls
      uniqueUrls = [...uniqueUrls,...uniqueHtmlUrls];
      uniqueUrls = [...new Set(uniqueUrls)];

      this.links = [];
      const targetPhrase = "?reportId=";
      uniqueUrls.forEach(x => {
        count++;
        let name = "Link " + count;
        let index = x.indexOf(targetPhrase);
        if (index > -1) {
          let endIndex = x.indexOf("-");
          let startIndex = index + targetPhrase.length;
          name = x.substring(startIndex, endIndex);
        }

        let links = data.filter(y => (y.url && y.url.indexOf(x) > -1) || (y.html && y.html.indexOf(x) > -1));
        if (links.length > 0) {
          links.forEach(link => {
            let surveyName = "";
            if (link.hspSurveyId) {
              const survey = this.getSurveyById(link.hspSurveyId);
              if (survey) {
                surveyName = survey.surveyName;
              }
            }

            let surveyUrlId = "All";
            if (link.orgSurveyId) {
              const orgSurvey = this.getOrgSurveyById(link.orgSurveyId);
              if (orgSurvey) {
                surveyUrlId = orgSurvey.surveyUrlId;
              }
            }

            let roleName = "All";
            if (link.roleId) {
              const role = this.roles.find(r => r.id === link.roleId)
              if (role) {
                roleName = role.name;
              }
            }

            const found = this.links.find(l => l.name === name);
            if (found) {
              const childId = found.children.length + 1;
              found.children.push({
                id: count.toString() + childId.toString(),
                hspReportLinkId: link.hspReportLinkId,
                name: found.name + "-" + childId.toString(),
                hspSurveyId: link.hspSurveyId,
                surveyName: surveyName,
                orgSurveyId: link.orgSurveyId,
                surveyUrlId: surveyUrlId,
                roleId: link.roleId,
                role: roleName,
                url: link.url,
                html: link.html,
                description: link.description,
                dataType: this.dataTypes.child,
              });
            }
            else {
              if (links.length === 1) {
                this.links.push({
                  id: count,
                  hspReportLinkId: link.hspReportLinkId,
                  name: name,
                  hspSurveyId: link.hspSurveyId,
                  surveyName: surveyName,
                  orgSurveyId: link.orgSurveyId,
                  surveyUrlId: surveyUrlId,
                  roleId: link.roleId,
                  role: roleName,
                  url: link.url,
                  html: link.html,
                  description: link.description,
                  dataType: this.dataTypes.parent,
                });
              }
              else {
                this.links.push({
                  id: count,
                  name: name,
                  hspSurveyId: link.hspSurveyId,
                  surveyName: "",
                  orgSurveyId: link.orgSurveyId,
                  surveyUrlId: "",
                  roleId: link.roleId,
                  role: "",
                  url: "",
                  html: "",
                  description: "",
                  dataType: this.dataTypes.header,
                  children: [{
                    id: count.toString() + "1",
                    hspReportLinkId: link.hspReportLinkId,
                    name: name + "-1",
                    hspSurveyId: link.hspSurveyId,
                    surveyName: surveyName,
                    orgSurveyId: link.orgSurveyId,
                    surveyUrlId: surveyUrlId,
                    roleId: link.roleId,
                    role: roleName,
                    url: link.url,
                    html: link.html,
                    description: link.description,
                    dataType: this.dataTypes.child,
                  }]                  
                });
              }
            }
          });
        }
      });

      this.sortLinks();
    },
    updateTitle() {
      let text = "URL";
      if (this.$route.params.surveyId) {
        text = this.getSurveyById(this.$route.params.surveyId).surveyName;
        if (this.$route.params.surveyUrlId) {
          text += " (" + this.$route.params.surveyUrlId + ")";
        }
      }
      else if (this.$route.params.surveyUrlId) {
        text = "Instance " + this.$route.params.surveyUrlId;
      }

      this.title = text;
    },
    sortLinks() {
      if (this.links.length === 0) {
        return;
      }

      // this.links.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      this.links.forEach(x => {
        if (x.children) {
          x.children.sort((a, b) => a.surveyName.toLowerCase().localeCompare(b.surveyName.toLowerCase()));
        }
      });
    },
    deleteFromLinks(data) {
      let retVal = { success: false, itemRemoved: null, removedIndex: -1 };
      let index = -1;
      let found = this.links.find(x => x.dataType !== this.dataTypes.header && x.hspReportLinkId === data.hspReportLinkId);
      if (found) {
        index = this.links.indexOf(found);
        if (index > -1) {
          retVal.success = true;
          retVal.removedIndex = index;
          retVal.itemRemoved = {...this.links[index]};
          this.links.splice(index, 1);

          return retVal;
        }
      }

      // Check the children
      for (let item of this.links) {
        found = item.children.find(x => x.hspReportLinkId === data.hspReportLinkId);
        if (!found) {
          continue;
        }

        index = item.children.indexOf(found);
        if (index > -1) {
          retVal.success = true;
          retVal.removedIndex = index;
          retVal.itemRemoved = {...item.children[index]};
          item.children.splice(index, 1);

          // If there's only one child left, move it to a parent data type
          if (item.children.length === 1) {
            const onlyChild = item.children[0];
            item.id = onlyChild.id,
            item.hspReportLinkId = onlyChild.hspReportLinkId;
            item.name = onlyChild.name;
            item.hspSurveyId = onlyChild.hspSurveyId;
            item.surveyName = onlyChild.surveyName;
            item.orgSurveyId = onlyChild.orgSurveyId;
            item.surveyUrlId = onlyChild.surveyUrlId;
            item.roleId = onlyChild.roleId;
            item.role = onlyChild.role;
            item.url = onlyChild.url;
            item.html = onlyChild.html;
            item.description = onlyChild.description;
            item.dataType = this.dataTypes.parent;
            item.children = [];
          }
          break;
        }
      }

      return retVal;
    },
    onDelete(row) {
      const linkId = row.hspReportLinkId;
      const name = row.name;
      swal.fire({
        title: 'Delete link',
        text: 'Are you sure you want to delete the link "' + name + '"?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          let payload = {
            id: row.hspReportLinkId,
          };

          deleteReportLink(payload)
          .then(response => {
            let result = response.data;
            let errorMessage = '';

            if(result.errors && result.errors.length) {
              result.errors.forEach(error => {
                errorMessage += `${error}<br>`
              });
              swal('Link Delete Error', errorMessage, 'error');
            }
            else {
              const delResult = this.deleteFromLinks(row);
              if (delResult.success) {
                swal('Link "' + delResult.itemRemoved.name + '" deleted', '', 'success');
              }
            }
          });
        }
      })
    },
    initialize() {
      this.routeInfo = { name: this.$route.name, path: this.$route.path };
      this.updateTitle();
      this.getLinks();
    },
    tableRowClassName({row, rowIndex}) {
      let className = "";
      if (row.dataType === this.dataTypes.header) {
        className = "row-highlight";
      }
      else if (this.multiChildrenLinks > 0 && row.dataType === this.dataTypes.parent) {
        className = "row-highlight-secondary";
      }
      
      return className;
    },
  },
  watch: {
    // Watch for routing into the same instance of the component. Reinitialize the links when the route has changed.
    $route: {
      handler() {
        if (this.routeInfo.name !== this.$route.name) {
          this.initialize();
        }
      },
      deep: true
    },
  },  
  async created() {
    await this.getRoles();
    this.initialize();
  }
};
</script>
